/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export {ALLOW_MULTIPLE_PLATFORMS as ÉµALLOW_MULTIPLE_PLATFORMS} from './application_ref';
export {APP_ID_RANDOM_PROVIDER as ÉµAPP_ID_RANDOM_PROVIDER} from './application_tokens';
export {defaultIterableDiffers as ÉµdefaultIterableDiffers, defaultKeyValueDiffers as ÉµdefaultKeyValueDiffers} from './change_detection/change_detection';
export {devModeEqual as ÉµdevModeEqual} from './change_detection/change_detection_util';
export {isListLikeIterable as ÉµisListLikeIterable} from './change_detection/change_detection_util';
export {ChangeDetectorStatus as ÉµChangeDetectorStatus, isDefaultChangeDetectionStrategy as ÉµisDefaultChangeDetectionStrategy} from './change_detection/constants';
export {Console as ÉµConsole} from './console';
export {inject, setCurrentInjector as ÉµsetCurrentInjector, ÉµÉµinject} from './di/injector_compatibility';
export {getInjectableDef as ÉµgetInjectableDef, ÉµÉµInjectableDef, ÉµÉµInjectorDef} from './di/interface/defs';
export {APP_ROOT as ÉµAPP_ROOT} from './di/scope';
export {DEFAULT_LOCALE_ID as ÉµDEFAULT_LOCALE_ID} from './i18n/localization';
export {ivyEnabled as ÉµivyEnabled} from './ivy_switch';
export {ComponentFactory as ÉµComponentFactory} from './linker/component_factory';
export {CodegenComponentFactoryResolver as ÉµCodegenComponentFactoryResolver} from './linker/component_factory_resolver';
export {clearResolutionOfComponentResourcesQueue as ÉµclearResolutionOfComponentResourcesQueue, resolveComponentResources as ÉµresolveComponentResources} from './metadata/resource_loading';
export {ReflectionCapabilities as ÉµReflectionCapabilities} from './reflection/reflection_capabilities';
export {GetterFn as ÉµGetterFn, MethodFn as ÉµMethodFn, SetterFn as ÉµSetterFn} from './reflection/types';
export {DirectRenderer as ÉµDirectRenderer, RenderDebugInfo as ÉµRenderDebugInfo} from './render/api';
export {_sanitizeHtml as Éµ_sanitizeHtml} from './sanitization/html_sanitizer';
export {_sanitizeStyle as Éµ_sanitizeStyle} from './sanitization/style_sanitizer';
export {_sanitizeUrl as Éµ_sanitizeUrl} from './sanitization/url_sanitizer';
export {global as Éµglobal} from './util/global';
export {looseIdentical as ÉµlooseIdentical,} from './util/comparison';
export {stringify as Éµstringify} from './util/stringify';
export {makeDecorator as ÉµmakeDecorator} from './util/decorators';
export {isObservable as ÉµisObservable, isPromise as ÉµisPromise} from './util/lang';
export {clearOverrides as ÉµclearOverrides, initServicesIfNeeded as ÉµinitServicesIfNeeded, overrideComponentView as ÉµoverrideComponentView, overrideProvider as ÉµoverrideProvider} from './view/index';
export {NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR as ÉµNOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR} from './view/provider';
export {getLocalePluralCase as ÉµgetLocalePluralCase, findLocaleData as ÉµfindLocaleData} from './i18n/locale_data_api';
export {LOCALE_DATA as ÉµLOCALE_DATA, LocaleDataIndex as ÉµLocaleDataIndex} from './i18n/locale_data';
